export default __webpack_public_path__ + "static/media/Declaration of Independence_08.384a2336.jpg";